import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit, Building2, ShieldCheck } from 'lucide-react';
export function FramingBand() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-surface-muted py-20 border-y border-line" data-id="element-303" data-mp="rnnhck7m7crw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304" data-mp="wniakuev4eg4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-4xl mx-auto mb-16" data-id="element-305" data-mp="wlyvh74y09fx">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-ink-dark leading-tight text-balance" data-id="element-306" data-mp="i6570r5hdonq">
            A New Infrastructure for Human Capability, Civic Development, and
            Leadership Readiness
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16" data-id="element-307" data-mp="3gr0dqtahlc1">
          {/* Column 1 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-308" data-mp="r2xjb8494lh1">
            <div className="w-14 h-14 rounded-full bg-white shadow-sm border border-line flex items-center justify-center mb-6 text-navy" data-id="element-309" data-mp="3bupv6p4iz0ny">
              <BrainCircuit size={28} strokeWidth={1.5} data-id="element-310" data-mp="37sl3hvxn0e3y" />
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-311" data-mp="39a05epn541o3">
              Human Capability Development
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-312" data-mp="3e94ivsh3klk8">
              Build stronger reasoning, regulation, and self-direction from
              early development through adulthood.
            </p>
          </motion.div>

          {/* Column 2 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-313" data-mp="2qjiix2swi2b6">
            <div className="w-14 h-14 rounded-full bg-white shadow-sm border border-line flex items-center justify-center mb-6 text-teal" data-id="element-314" data-mp="2vbk278ohktap">
              <Building2 size={28} strokeWidth={1.5} data-id="element-315" data-mp="2gk1h4wgrs8kh" />
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-316" data-mp="2ll8mkovfwvnz">
              Institutional Readiness
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-317" data-mp="2bmrq5cdqfouj">
              Support schools, employers, civil society, and public systems with
              actionable capability metrics.
            </p>
          </motion.div>

          {/* Column 3 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-318" data-mp="1o0pgefnj8j2d">
            <div className="w-14 h-14 rounded-full bg-white shadow-sm border border-line flex items-center justify-center mb-6 text-navy-light" data-id="element-319" data-mp="21wsyjal4t0yh">
              <ShieldCheck size={28} strokeWidth={1.5} data-id="element-320" data-mp="2bwbfdi5qw6mb" />
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-321" data-mp="26yi8so0j5ali">
              Leadership Qualification
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-322" data-mp="2koddh9scdatf">
              Strengthen readiness for high-responsibility roles, crisis
              management, and governance stability.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}